import styled from 'styled-components'
import { Button } from '../../../../buttons/Button/Button'
import { IconCheck } from '../../../../iconography/Icons/Icons'

export const IconCheckCircle = styled(IconCheck)`
  position: absolute;
  top: 20px;
  left: 17px;
  width: 32px;
  height: 24px;
  color: ${props => props.theme.color.outlinePrimary};
`

export const IconBorder = styled.div`
  width: 64px;
  height: 64px;
  top: 64px;
  left: 288px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.color.secondary300};
  position: absolute;

  ${props => props.theme.media.mobile`
    left: 208px;
  `}
`

export const StepQuestionnaireWrapper = styled.div`
  width: 560px;

  ${props => props.theme.media.mobile`
    width: 408px;
  `}
`

export const ProductContainer = styled.div`
  font-weight: 600;
  padding-top: 136px;
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid ${props => props.theme.color.secondary100};
`

export const Footer = styled.div`
  height: 54%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
`

export const SkipAndClose = styled.div`
  line-height: 22px;
  color: ${props => props.theme.color.secondary300};
  cursor: pointer;
`

export const GoToCartButton = styled(Button)`
  margin-top: 12px;
`
export const ShowQuestionnaire = styled.div<{ show: boolean }>`
  margin-top: 24px;
  margin-bottom: ${props => !props.show && '20px'};
  color: #037bff;
  cursor: pointer;
`
